import { useState } from "react";
import Pagination from "../../../componentes/pagination/Pagination";
import { formatLocalDateTime, returnDate } from "../../../utils/formatDate";

export function TabelaConciliacao({ dadosFiltrados }) {
    const [changeData, setChangeData] = useState([]);

    return (
        <>
            <div className="table-responsive overflow-y-auto" style={{ maxHeight: "80vh" }}>
                <table className="table text-sm text-left text-muted-foreground">
                    <thead className="bg-table-header text-table-header-fg sticky top-0">
                        <tr>
                            <th className="px-4 py-3">EMPRESA</th>
                            <th className="px-4 py-3">DATA</th>
                            <th className="px-4 py-3">CONTA</th>
                            <th className="px-4 py-3">REDUZIDO</th>
                            <th className="px-4 py-3">DESCRICAO</th>
                            <th className="px-4 py-3">ESTAB.</th>
                            <th className="px-4 py-3">CENTRO</th>
                            <th className="px-4 py-3">CHAVE</th>
                            <th className="px-4 py-3">HISTORICO</th>
                            <th className="px-4 py-3 text-right">VALOR</th>
                            <th className="px-4 py-3">CONTA C/P</th>
                            <th className="px-4 py-3">DESCRIÇÃO C/P</th>
                            <th className="px-4 py-3">C/P REDUZIDO</th>
                            <th className="px-4 py-3">DATA/HORA</th>
                            <th className="px-4 py-3">USUARIO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {changeData.map((item, idx) => (
                            <tr key={idx} className="table-items hover:bg-table-row-hover transition-colors">
                                <td className="px-4 py-3">{item.empresa}</td>
                                <td className="px-4 py-3">{returnDate(item.data)}</td>
                                <td className="px-4 py-3">{item.conta}</td>
                                <td className="px-4 py-3">{item.reduzido}</td>
                                <td className="px-4 py-3">{item.contaNome}</td>
                                <td className="px-4 py-3">{item.filial}</td>
                                <td className="px-4 py-3">{item.centroCusto}</td>
                                <td className="px-4 py-3">{item.sequencial}</td>
                                <td className="px-4 py-3">{item.complemento}</td>
                                <td className={`text-right ${item.movimento === 1 ? "text-foreground" : "text-destructive"}`}>
                                    {item.valor.toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                                    {item.movimento === 1 ? "D" : "C"}
                                </td>
                                <td className="px-4 py-3">{item.contaCp}</td>
                                <td className="px-4 py-3">{item.contaCpNome}</td>
                                <td className="px-4 py-3">{item.contaCpReduzido}</td>
                                <td className="px-4 py-3">{formatLocalDateTime(item.dataHora)}</td>
                                <td className="px-4 py-3">{item.usuario}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Pagination
                data={dadosFiltrados}
                length={changeData.length}
                currentData={setChangeData}
            >
                {(() => {
                    const totalCredito = dadosFiltrados
                        .filter(x => x.movimento === -1)
                        .reduce((acc, x) => acc + (x.valor || 0), 0);

                    const totalDebito = dadosFiltrados
                        .filter(x => x.movimento === 1)
                        .reduce((acc, x) => acc + (x.valor || 0), 0);

                    const saldo = totalDebito - totalCredito;

                    return (
                        <div className="flex flex-wrap gap-6 mt-3 mb-6">
                            <label>
                                VL Crédito:{" "}
                                <strong>
                                    {totalCredito.toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    })}
                                </strong>
                            </label>
                            <label>
                                VL Débito:{" "}
                                <strong>
                                    {totalDebito.toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    })}
                                </strong>
                            </label>
                            <label>
                                Saldo:{" "}
                                <strong>
                                    {saldo.toLocaleString("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    })}
                                </strong>
                            </label>
                        </div>
                    );
                })()}
            </Pagination>
        </>
    );
}
